import { Navigate, useTypedParams } from '@sorare/routing';

import { ANY_SPORT_MARKET_WATCHLISTS_ID } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { PageParams } from './__generated__/routeParams';

const RedirectToWatchlistsIdPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { id } = useTypedParams<PageParams>();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MARKET_WATCHLISTS_ID, {
        params: { id },
      })}
    />
  );
};

export default RedirectToWatchlistsIdPage;
